import React from 'react';

const Search = ({
  color = "#333",
  w = '24',
  h = '24',
}: {
  color?: string;
  w?: string;
  h?: string;
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' stroke={color} strokeWidth='1.5'>
        <circle cx='12' cy='12' r='7' />
        <path strokeLinecap='round' d='M11 8a3 2 0 0 0-2 3m12 9l-2-2' />
      </g>
    </svg>
  );
};

export default Search;
